import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "chevronDown"
const ChevronDownIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42Z"
      />
    </svg>
  )
}
export default ChevronDownIcon
